import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-no-permission-box',
  templateUrl: './no-permission-box.component.html',
  styleUrls: ['./no-permission-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoPermissionBoxComponent {}
